export default __webpack_public_path__ + "static/media/CloseIcon.db62d110.svg";